import { RootState } from '../store'
import { IMatchedPFGrant, IPrivateFoundation } from '../../types'
import { createSelector } from '@reduxjs/toolkit'
import moment from 'moment'

const getMatchedPFs = (state: RootState) => state.matchedPFs.data
const getPaging = (state: RootState) => state.matchedPFs.paging
const getLoading = (state: RootState) => state.matchedPFs.loading

const makeMatchedPFs = createSelector([getMatchedPFs], (matchedPFs) => {
  return matchedPFs.map((matchedPF) => {
    const {
      technologyTitle = '' ,
      privateFoundation = {} as IPrivateFoundation,
      _id : matchedPFId = '', grants = [] as IMatchedPFGrant[],
      ...matched
    } = matchedPF

    const {
      organizationUrl = '',
      organizationDescription = '',
      contriPaidDsbrsChrtblAmt: disbursedCharityAmount = 0,
      ...pf
    } = privateFoundation

    const formattedCharityAmount = disbursedCharityAmount.toLocaleString('en-US')

    const formattedGrants = grants.map(({_id, title = '', dueDate: ISODate = '', amount = 0, ...rest}) => {
      const formattedAmount = amount.toLocaleString('en-US')

      const dueDate = (ISODate && moment.utc(ISODate).format('MMMM D, YYYY')) || ''

      return {
        ...rest,
        _id,
        title,
        amount,
        dueDate,
        ISODate,
        formattedAmount,
      }
    })

    return {
      ...pf,
      ...matched,
      matchedPFId,
      technologyTitle,
      organizationUrl,
      formattedCharityAmount,
      disbursedCharityAmount,
      organizationDescription,
      grants: formattedGrants,
    }
  })
})

const makePipelinePFs = createSelector(makeMatchedPFs, (pfs) => {
  return pfs.reduce((acc: Record<string, { pfs: typeof pfs; totalAmount: number }>, pf) => {
    if (pf.status !== 'selected') {
      return acc
    }

    const { progressStatus = 'unknown', disbursedCharityAmount = 0 } = pf

    if (!acc[progressStatus]) {
      acc[progressStatus] = {
        pfs: [],
        totalAmount: 0,
      }
    }

    acc[progressStatus].pfs.push(pf)
    acc[progressStatus].totalAmount += disbursedCharityAmount

    return acc
  }, {})
})

const makePipelineHasData = createSelector(makePipelinePFs, (pipelinePFs:any) => {
  const stages = Object.keys(pipelinePFs)

  return stages.length > 0 && stages.some(stage => pipelinePFs[stage].pfs.length > 0)
})

const makeMatchedPFTotalAmount = createSelector([makeMatchedPFs], (matchedPFs) => {
  return matchedPFs.reduce((acc, curr) => acc + curr.disbursedCharityAmount, 0)
})

export const MatchedPFsSelectors = {
  getMatchedPFs,
  getLoading,
  getPaging,
  makeMatchedPFs,
  makePipelinePFs,
  makePipelineHasData,
  makeMatchedPFTotalAmount,
}
